import React, {  } from 'react';

import { listFormatOptions } from '../types';
import { ListFormatInput, ListFormatRuleSet } from './Intl.ListFormat';
import { IntlFunction } from './Intl.Function';

export const IntlListFormatFormat = () => (
	<IntlFunction
		input={ListFormatInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/ListFormat/format"
		header="Intl.ListFormat.prototype.format"
		description="Returns a string with a language-specific representation of the list."
		options={listFormatOptions}
		ruleSet={ListFormatRuleSet}
		template="new Intl.ListFormat(##locale##, ##options##).format(##input:raw##)" />
);
